// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewCommentsList.test.tsx
import { type ReactNode } from "react";

import { type LinkableClaim } from "../../plugins/rehype-claim-citation";
import { CommentSectionBody } from "../../routes/ask-puntt/components/AssetViewerPane";
import { type LinkableMemory } from "../../utils/memoryCitationFields";

type AskPunttReviewCommentBodyProps = {
  commentId: string;
  description: string;
  afterExpand?: ReactNode;
  /** Registry claims this comment cites; a quoted one becomes a link. */
  claimCitations?: LinkableClaim[];
  /** Saved memories this comment rests on; the sentence each supports takes a chip. */
  memoryCitations?: LinkableMemory[];
};

export function AskPunttReviewCommentBody({
  commentId,
  description,
  afterExpand,
  claimCitations,
  memoryCitations,
}: AskPunttReviewCommentBodyProps) {
  return (
    <CommentSectionBody
      commentId={commentId}
      description={description}
      clampCommentSections={false}
      slotAfterExpand={afterExpand}
      claimCitations={claimCitations}
      memoryCitations={memoryCitations}
    />
  );
}
